export enum PokerChipValue {
  ONE_CENT = 0.01,
  FIVE_CENT = 0.05,
  TWENTY_FIVE_CENT = 0.25,
  ONE = 1,
  FIVE = 5,
  TWENTY_FIVE = 25,
  ONE_HUNDRED = 100,
  FIVE_HUNDRED = 500,
  ONE_THOUSAND = 1000,
  FIVE_THOUSAND = 5000,
  TWENTY_FIVE_THOUSAND = 25000,
}
